import camelCase from 'lodash/camelCase';

import { toSentenceCase } from '../../utils';

export const makeColumns = (cols, renderEditableCell) => {
  const columns = [];
  cols.forEach((col) => {
    columns.push({
      Header: toSentenceCase(col.name),
      accessor: camelCase(col.name),
      headerClassName: 'sort',
      Cell: renderEditableCell,
    });
  });
  return columns;
};

export const makeRows = (cols, data) => {
  const entries = [];
  data.forEach((item) => {
    const row = {};
    item.forEach((value, i) => {
      row[camelCase(cols?.[i]?.name)] = String(value).trim();
    });
    entries.push({
      ...row,
    });
  });
  return entries;
};

export const SheetJSFT = [
  'xlsx',
  'xlsb',
  'xlsm',
  'xls',
  'xml',
  'csv',
  'txt',
  'ods',
  'fods',
  'uos',
  'sylk',
  'dif',
  'dbf',
  'prn',
  'qpw',
  '123',
  'wb*',
  'wq*',
  'html',
  'htm',
]
  .map((x) => `.${x}`)
  .join(',');
